import { createContext } from 'react';

export const EditLegalEntitiesDrawerContext = createContext(null);
